import React from 'react';
import { motion } from 'framer-motion';
import { HERO_IMAGE_URL, SITE_NAME, BRAND_COLOR } from '../constants';

const Hero: React.FC<{ isDarkMode: boolean }> = ({ isDarkMode }) => {
  const nameParts = SITE_NAME.split(' ');

  return (
    <section id="home" className={`relative h-screen flex items-center overflow-hidden transition-colors duration-500 ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
      <div className="absolute inset-0 z-0">
        <motion.img 
          initial={{ scale: 1.1, opacity: 0 }} 
          animate={{ scale: 1, opacity: isDarkMode ? 0.5 : 0.7 }} 
          transition={{ duration: 1.5 }}
          src={HERO_IMAGE_URL} 
          className="w-full h-full object-cover"
        />
        <div className={`absolute inset-0 ${isDarkMode ? 'bg-gradient-to-t from-black via-black/40 to-black' : 'bg-white/40'}`}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <motion.p 
          initial={{ opacity: 0, x: -20 }} 
          animate={{ opacity: 1, x: 0 }} 
          className={`font-black tracking-[0.6em] uppercase text-[13px] mb-4 md:mb-6 transition-colors duration-500 ${isDarkMode ? 'text-white' : 'text-black'}`}
        >
          Est 2017 Boston, MA
        </motion.p>
        <motion.h1 
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} 
          className={`font-display text-5xl sm:text-7xl md:text-[7rem] lg:text-[8.5rem] font-black leading-[0.85] tracking-tighter uppercase mb-6 md:mb-8 ${isDarkMode ? 'text-white' : 'text-black'}`}
        >
          {nameParts[0]} <br />
          <span style={{ color: BRAND_COLOR }}>{nameParts.slice(1).join(' ')}.</span>
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ delay: 0.3 }} 
          className={`text-sm md:text-xl max-w-2xl mb-10 transition-colors duration-500 font-black uppercase tracking-wider leading-relaxed ${isDarkMode ? 'text-white' : 'text-black'}`}
        >
          High-contrast frames for sharp portraits, high-stakes events, and bold creators. Defining the visual edge.
        </motion.p>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }} className="flex flex-col sm:flex-row gap-4">
          <button 
            onClick={() => document.getElementById('work')?.scrollIntoView({ behavior: 'smooth' })} 
            style={{ backgroundColor: BRAND_COLOR }} 
            className="px-10 md:px-12 py-4 md:py-5 text-black font-black uppercase tracking-widest text-xs hover:brightness-110 transition-all text-center"
          >
            VIEW WORK
          </button>
          <button 
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} 
            className={`border px-10 md:px-12 py-4 md:py-5 font-black uppercase tracking-widest text-xs transition-colors text-center ${isDarkMode ? 'border-white/40 text-white hover:border-white' : 'border-black/40 text-black hover:border-black'}`}
          >
            PACKAGES
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
